import { DatePicker } from '@scale/scaleui';
import { IDate } from 'dashboard/hooks/useFilters';
import moment from 'moment';
import React, { memo, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  selectedDateTo: IDate;
  selectedDateFrom: IDate;
  handleChange: (value: [IDate, IDate] | undefined) => void;
  disableDateFilter?: boolean;
  className?: string;
}

const DAY = 86400000; // milliseconds in a day
const WEEK = DAY * 7;
const MONTH = DAY * 30;

const DateRangePicker: React.FC<Props> = ({
  selectedDateFrom,
  selectedDateTo,
  handleChange,
  className,
}) => {
  const { nowDate, past7Days, past2Weeks, pastMonth, past3Months } = useMemo(() => {
    const nowMillis = Date.now();
    const nowDate = new Date(nowMillis);

    const past7Days = new Date(nowMillis - WEEK);
    const past2Weeks = new Date(nowMillis - 2 * WEEK);
    const pastMonth = new Date(nowMillis - MONTH);
    const past3Months = new Date(nowMillis - 3 * MONTH);

    return { nowDate, past7Days, past2Weeks, pastMonth, past3Months };
  }, []);

  return (
    <div className={twMerge('scaleui scale-tailwind scale-theme', className)}>
      <DatePicker
        value={
          selectedDateFrom && selectedDateTo
            ? [selectedDateFrom.toDate(), selectedDateTo.toDate()]
            : undefined
        }
        className=""
        isRangePicker
        onChange={dates => {
          if (!dates) {
            handleChange(dates);
          }
          handleChange([moment(dates[0]), moment(dates[1])]);
        }}
        placeholder="Select a date"
        rangesOptions={[
          {
            label: 'Past 7 days',
            value: [past7Days, nowDate],
          },
          {
            label: 'Past 2 weeks',
            value: [past2Weeks, nowDate],
          },
          {
            label: 'Past month',
            value: [pastMonth, nowDate],
          },
          {
            label: 'Past 3 months',
            value: [past3Months, nowDate],
          },
        ]}
      />
    </div>
  );
};

export default memo(DateRangePicker);
